import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tag-input" }
const _hoisted_2 = {
  key: 0,
  class: "input-label"
}
const _hoisted_3 = { class: "tags-container" }
const _hoisted_4 = { class: "tag-text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["placeholder", "onKeydown"]

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TagInput',
  props: {
    modelValue: {},
    label: {},
    placeholder: { default: 'Add item...' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const inputValue = ref('')

const addTag = () => {
  const value = inputValue.value.trim()
  if (value && !props.modelValue.includes(value)) {
    emit('update:modelValue', [...props.modelValue, value])
  }
  inputValue.value = ''
}

const removeTag = (index: number) => {
  const newTags = [...props.modelValue]
  newTags.splice(index, 1)
  emit('update:modelValue', newTags)
}

const handleBackspace = () => {
  if (inputValue.value === '' && props.modelValue.length > 0) {
    removeTag(props.modelValue.length - 1)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (tag, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "tag"
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(tag), 1),
          _createElementVNode("button", {
            class: "tag-remove",
            onClick: ($event: any) => (removeTag(index))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none"
            }, [
              _createElementVNode("path", {
                d: "M3 3L9 9M3 9L9 3",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round"
              })
            ], -1)
          ]))], 8, _hoisted_5)
        ]))
      }), 128)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        type: "text",
        class: "tag-text-input",
        placeholder: __props.modelValue.length === 0 ? __props.placeholder : '',
        onKeydown: [
          _withKeys(_withModifiers(addTag, ["prevent"]), ["enter"]),
          _withKeys(handleBackspace, ["backspace"])
        ],
        onBlur: addTag
      }, null, 40, _hoisted_6), [
        [_vModelText, inputValue.value]
      ])
    ])
  ]))
}
}

})